<template>
    <div class="surface-0 overflow-hidden">
        <Topbar :setting="setting"/>
        <Toast/>
        <slot/>
        <Footer :setting="setting" />
    </div>
</template>

<script>
import axios from "axios";
import { Link } from "@inertiajs/inertia-vue3";
import Ripple from "primevue/ripple";
import Toast from 'primevue/toast';
import Topbar from "../Pages/Landing/Topbar";
import Footer from "../Pages/Landing/Footer";

export default {
    components: {
        Ripple,
        Link,
        Topbar,
        Footer,
        Toast,
    },
    data(){
        return{
            setting: {},
        }
    },
    created(){
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/setting-frontends`)
            .then((data)=> {
                this.setting = data.data;
            });
        },
    }
};
</script>

<style>
#hero {
    background: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0.2),
            rgba(255, 255, 255, 0.2)
        ),
        radial-gradient(
            77.36% 256.97% at 77.36% 57.52%,
            #eeefaf 0%,
            #c3e3fa 100%
        );
    height: 700px;
    overflow: hidden;
}

@media screen and (min-width: 768px) {
    #hero {
        -webkit-clip-path: ellipse(150% 87% at 93% 13%);
        clip-path: ellipse(150% 87% at 93% 13%);
        height: 530px;
    }
}

@media screen and (min-width: 1300px) {
    #hero > img {
        position: absolute;
    }

    #hero > div > p {
        max-width: 450px;
    }
}

@media screen and (max-width: 1300px) {
    #hero {
        height: 600px;
    }

    #hero > img {
        position: static;
        transform: scale(1);
        margin-left: auto;
    }

    #hero > div {
        width: 100%;
    }

    #hero > div > p {
        width: 100%;
        max-width: 100%;
    }
}
</style>
